import { type Dictionary } from '@ngrx/entity';

import { type RowActionPageConfig } from './row-action-page-generation.models';

export const ROW_ACTION_PAGES_CONFIG: Dictionary<RowActionPageConfig> = {
  'content.itemEdit.enabled': {
    actionPath: 'content.itemEdit',
    pregenerationType: 'edit',
    pageType: 'Dialog',
  },
  'content.itemView.enabled': {
    actionPath: 'content.itemView',
    pregenerationType: 'view',
    pageType: 'Page',
  },
  'content.itemViewDialog.enabled': {
    actionPath: 'content.itemViewDialog',
    pregenerationType: 'view-dialog',
    pageType: 'Dialog',
  },
} as const;
